import React from "react";
import RevealSection from "../RevealSection";

const POINTS = [
  {
    title: "You are our customer. Not our product.",
    body: "GuMi earns from job seekers, not from the companies you're researching. No conflict. No hidden agenda.",
  },
  {
    title: "Your data stays yours.",
    body: "We never sell your resume, skills, or profile to employers.",
  },
  {
    title: "You're invisible by default.",
    body: "Nobody can find you on GuMi without your explicit permission.",
  },
  {
    title: "Delete everything, anytime.",
    body: "Delete your account from Settings by typing DELETE to confirm. Your profile, resumes, analyses, and application history are removed. No waiting. No dark patterns.",
  },
  {
    title: "We profit from intelligence. Not attention.",
    body: "No ads. No sponsored jobs. No employer pressure on our signals.",
  },
];

export const UserContract = () => {
  return (
    <section
      data-testid="user-contract-section"
      style={{ background: "#1a1a18", padding: "100px 24px", textAlign: "center" }}
    >
      <RevealSection>
        <h2
          className="font-heading"
          style={{ fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 700, letterSpacing: "-1px", lineHeight: 1.1, color: "white", marginBottom: 48 }}
        >
          Our contract with you.
        </h2>
      </RevealSection>

      <div className="contract-grid" style={{ maxWidth: 720, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 32px" }}>
        {POINTS.map((p, i) => (
          <RevealSection key={p.title} delay={(i % 4) + 1} className="contract-point">
            <div style={{ display: "flex", alignItems: "flex-start", gap: 14, textAlign: "left", marginBottom: 24 }}>
              <span
                aria-hidden="true"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: "rgba(29,158,117,0.15)",
                  color: "#1D9E75",
                  fontSize: 14,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                ✓
              </span>
              <div>
                <p className="font-body" style={{ fontSize: 14, fontWeight: 600, color: "white" }}>
                  {p.title}
                </p>
                <p className="font-body" style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", lineHeight: 1.5, marginTop: 4 }}>
                  {p.body}
                </p>
              </div>
            </div>
          </RevealSection>
        ))}
      </div>
    </section>
  );
};

export default UserContract;
